/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../../../application";
import { SECTION_OPT_INVENTORY_REPORT } from "../graphql/sectionOptInventoryReport.query";
import { pretty } from "@vlinder-web/utils-react";


const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface ISectionOptInventoryReportMethods extends IPluginMethodMap {
  sectionOptInventoryReport(args: any): Promise<any>;
}

export class SectionOptInventoryReportService implements IAgentPlugin {
  readonly methods: ISectionOptInventoryReportMethods;

  constructor() {
    this.methods = {
      sectionOptInventoryReport: this.sectionOptInventoryReport.bind(this),
    };
  }

  async sectionOptInventoryReport(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    let filter = {}
    if (args?._id) {
      filter = {
        ...filter,
        costumeType: {
          eq: args?._id
        }
      }
    }
    if (args?.fid && args?.fid !== null) {
      filter = {
        ...filter,
        _id: {
          eq: args?.fid
        }
      }
    }
    if (args?.attributeId && args?.attributeId !== "-" && args?.attributeId !== "") {
      filter = {
        ...filter,
        CA___name: {
          eq: args?.attributeId
        }
      }
    }
    if (args?.valueId && args?.valueId !== "-" && args?.valueId !== "") {
      filter = {
        ...filter,
        CV___name: {
          eq: args?.valueId
        }
      }
    }

    try {
      if (client) {
        const res = await client.query({
          query: SECTION_OPT_INVENTORY_REPORT,
          variables: { filters: filter },
          fetchPolicy: "network-only",
        });
        console.log("ROORORO--->", res);
        return res;
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }

  private convertCriteria(criteria: any) {
    const result: any = {};
    for (const key in criteria) {
      result[key] = { contains: criteria[key] };
    }
    return result;
  }
}
